import React, { useState } from 'react';
import CardDatas from '../../components/CardDatas'
import CardSalas from '../../components/CardSalas';
import Modal from '../../components/Modal';
import './styles.css';

const PaginaInicialDesktop = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const handleScheduleClick = (roomName, schedule) => {
    setSelectedSchedule({ roomName, ...schedule });
  };

  const handleDateClick = (date) => {
    setSelectedDate(date); // Atualiza a data selecionada
  };

  const closeModal = () => {
    setSelectedSchedule(null);
  };

  return (
    <div className="CardPrincipal">
      <CardDatas onDateClick={handleDateClick} />
      <CardSalas onClickSchedule={handleScheduleClick} selectedDate={selectedDate} />
      {selectedSchedule && (
        <Modal
          selected={{
            ...selectedSchedule,
            roomId: selectedSchedule.roomId, // Certifique-se de que o roomId está sendo passado
          }}
          close={closeModal}
        />
      )}
    </div>
  );
};

export default PaginaInicialDesktop;